/**
 * Centralized query keys for Opportunities feature
 * All files in this feature should import and use these constants
 * instead of hardcoding query key strings.
 */

export const OPPORTUNITY_NOTES_QUERY_KEY = 'opportunityNotes';
export const OPPORTUNITY_QUERY_KEY = 'opportunity';
export const OPPORTUNITIES_LIST_QUERY_KEY = 'opportunities';

/**
 * Query key for active opportunities list (used in connection dialogs)
 * This should be invalidated when opportunities are created or updated
 */
export const getActiveOpportunitiesQueryKey = () =>
  [OPPORTUNITIES_LIST_QUERY_KEY, 'active'] as const;
